<template>
  <div>
    <div class='type'>
      <el-form>
        <el-form-item label='账号类型'>
          <el-select v-model='adminType' placeholder='请选择' @change='() => { getAdminLinst(adminType) }'>
            <el-option v-for='item in options' :key='item.value' :label='item.label' :value='item.value'>
            </el-option>
          </el-select>

          <el-button type='primary' @click='add()'>添加账号</el-button>

        </el-form-item>
      </el-form>
    </div>
    <el-table :data='tableData' border style='width: 100%'>
      <el-table-column prop='name' label='姓名' width='120'> </el-table-column>
      <el-table-column prop='account' label='账号'> </el-table-column>
      <el-table-column prop='telephone' label='电话'> </el-table-column>

      <el-table-column prop='ctype' label='账号类型'> </el-table-column>
      <el-table-column fixed='right' label='操作' width='100'>
        <template slot-scope='scope'>
          <el-button @click='setList(scope.row)' type='text' size='small'>修改</el-button>
          <el-button @click='del(scope.row)' type='text' size='small'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync='dialogVisible' :before-close='
      () => {
        dialogVisible = false;
        ruleForm = {}
      }
    '>
      <div>
        <el-form :model='ruleForm' status-icon :rules='rules' ref='ruleForm' label-width='100px' class='demo-ruleForm'>
          <el-form-item label='名字' prop='name'>
            <el-input v-model='ruleForm.name'></el-input>
          </el-form-item>
          <el-form-item label='账号类型'>
            <el-select v-model='ruleForm.ctype' placeholder='请选择' @change='() => { getAdminLinst(adminType) }'>
              <el-option v-for='item in options' :key='item.value' :label='item.label' :value='item.value'>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='电话' prop='telephone'>
            <el-input type='tel' v-model='ruleForm.telephone' autocomplete='off'></el-input>
          </el-form-item>
          <el-form-item label='账号' prop='account'>
            <el-input v-model='ruleForm.account' autocomplete='off'></el-input>
          </el-form-item>
          <el-form-item label='密码' prop='password'>
            <el-input type='password' v-model='ruleForm.password' autocomplete='off'></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type='primary' @click="submitForm('ruleForm')">确认</el-button>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <span slot='footer' class='dialog-footer'>
          <el-button @click='dialogVisible = false'>取 消</el-button>
          <el-button type='primary' @click='dialogVisible = false'
            >确 定</el-button
          >
        </span> -->
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'adminList',
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('名字不能为空'));
      } else {
          callback();
      }
    //   setTimeout(() => {
    //     if (!Number.isInteger(value)) {
    //       callback(new Error('请输入数字值'));
    //     } else {
    //       if (value < 18) {
    //         callback(new Error('必须年满18岁'));
    //       } else {
    //         callback();
    //       }
    //     }
    //   }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var telephone = (rule, value, callback) => {
      let tel = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
    
      if (value === '') {
        callback(new Error('请输入电话号码'));
      } else {
        if (!tel.test(value)) {
          callback(new Error('请输入正确的手机号'));
        }
        callback();
      }
    };
    var password = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value === this.ruleForm.account) {
        callback(new Error('账号和密码不能一致'));
      } else {
        callback();
      }
    };
    return {
      tableData: '',
      dialogVisible: false,
      options: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '招生',
          label: '招生',
        },
        {
          value: '就业',
          label: '就业',
        },
        {
          value: '教学',
          label: '教学',
        },
        {
          value: '学生工作',
          label: '学生工作',
        },
        {
          value: '生活服务',
          label: '生活服务',
        },
        {
          value: '人才招聘',
          label: '人才招聘',
        },
        {
          value: '出国留学',
          label: '出国留学',
        },
      ],
      adminType: '',
      id:'',
      ruleForm: {
        password: '',
        account: '',
        name: '',
        ctype:'',
        telephone:''
      },
      rules: {
        telephone: [{ validator: telephone, trigger: 'blur' }],
        account: [{ validator: validatePass, trigger: 'blur' }],
        password: [{ validator: password, trigger: 'blur' }],
        name: [{ validator: checkAge, trigger: 'blur' }],
      },
      addOrSet:true
    };
  },
  mounted() {
    this.getAdminLinst(this.adminType);
  },
  methods: {
    async getAdminLinst(ctype = '') {
      let data = await this.$http.adminList({ctype});
      this.tableData = data.records
    },
    handleClick(row) {
      console.log(row);
    },
    setList(row) {
      this.addOrSet = false
        this.dialogVisible = true
        this.ruleForm.name = row.name
        this.ruleForm.account = row.account
        this.ruleForm.telephone = row.telephone
        this.ruleForm.ctype = row.ctype
        this.id = row.id
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(JSON.stringify({...this.ruleForm,id:this.id}));
          if (this.addOrSet) {
            let data = await this.$http.adminAdd({...this.ruleForm,id:this.id});
          } else {
            // {'id':'1537268965421350913','name':'鲁迅','account':'luxun2','ctype':'招生','account':'22688001022','password':'123'}
            let data = await this.$http.adminSet({...this.ruleForm,id:this.id});
          }
        } else {
          console.log('error submit!!');
          return false;
        }
        this.adminType = ''
        this.getAdminLinst(this.adminType);
        this.dialogVisible = false
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false
    },
    async del(row){
      let data = await this.$http.adminDel(row.id)
    },
    add(){
      this.addOrSet = true
      this.dialogVisible = true
      this.ruleForm = {}
      // let data = await this.$http.adminAdd(JSON.stringify({...this.ruleForm,...this.id}))
    }
  },
};
</script>

<style lang='scss' scoped>
.type {
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/adminList.vue